import axios from "@/axios"

const url = "/api/specimens"

class GlobalSearchService {
	async getSpecimens(params) {
		try {
			const { data } = await axios.get(`${url}/global-search-header`, { params })
			return data
		} catch (error) {
			throw error
		}
	}
}

export default new GlobalSearchService()
